const COLORS = {
  indigo90: '#8C82FF',
  indigo: '#5528ff',
  indigo110: '#280f96',
  egg50: '#ffd87f',
  black35: '#a6a6a6',
  white: '#ffffff',
};

export default COLORS;
